/**
 * Verlanglijst-knop (product Luxury): zelfde localStorage-key als theme Wishlist.js (`user_wishlist`),
 * plus cookie-spiegel voor backup als localStorage faalt of leeg is.
 * `user_wishlist_meta`: { [productId]: handle } voor Ajax-wishlist op de pagina (producten buiten Liquid-limiet).
 */
(function () {
  'use strict';

  var LS_KEY = 'user_wishlist';
  var META_KEY = 'user_wishlist_meta';
  var COOKIE_KEY = 'uf_wishlist_mirror';
  var COOKIE_MAX_AGE = 86400 * 400;

  function toIdList(arr) {
    if (!Array.isArray(arr)) return [];
    return arr.map(function (x) {
      return String(x);
    });
  }

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function writeCookie(name, value) {
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      ';path=/;max-age=' +
      COOKIE_MAX_AGE +
      ';SameSite=Lax';
  }

  function readMeta() {
    try {
      var o = JSON.parse(localStorage.getItem(META_KEY) || '{}');
      return o && typeof o === 'object' ? o : {};
    } catch (e) {
      return {};
    }
  }

  function writeMeta(m) {
    try {
      localStorage.setItem(META_KEY, JSON.stringify(m));
    } catch (e) {}
  }

  function pruneMetaToIds(uniq) {
    var meta = readMeta();
    var next = {};
    uniq.forEach(function (id) {
      if (meta[id]) next[id] = meta[id];
    });
    writeMeta(next);
  }

  function parseList() {
    if (typeof window.ufWishlistReadIds === 'function') {
      return window.ufWishlistReadIds();
    }
    var a = [];
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (raw) a = JSON.parse(raw);
    } catch (e) {}
    a = toIdList(a);
    if (a.length === 0) {
      try {
        var c = readCookie(COOKIE_KEY);
        if (c) a = toIdList(JSON.parse(c));
      } catch (e2) {}
    }
    return a;
  }

  function persist(arr) {
    if (typeof window.ufWishlistPersistIds === 'function') {
      pruneMetaToIds(window.ufWishlistPersistIds(arr));
      if (typeof window.ufNotifyWishlistUpdated === 'function') {
        window.ufNotifyWishlistUpdated();
      }
      return;
    }
    var seen = {};
    var uniq = [];
    toIdList(arr).forEach(function (id) {
      if (!seen[id]) {
        seen[id] = true;
        uniq.push(id);
      }
    });
    pruneMetaToIds(uniq);
    var s = JSON.stringify(uniq);
    try {
      localStorage.setItem(LS_KEY, s);
    } catch (e) {}
    writeCookie(COOKIE_KEY, s);
    if (typeof window.ufNotifyWishlistUpdated === 'function') {
      window.ufNotifyWishlistUpdated();
    }
  }

  function syncCookieToLocalStorage() {
    try {
      if (localStorage.getItem(LS_KEY)) return;
      var c = readCookie(COOKIE_KEY);
      if (!c) return;
      var a = JSON.parse(c);
      if (Array.isArray(a) && a.length) localStorage.setItem(LS_KEY, JSON.stringify(toIdList(a)));
    } catch (e) {}
  }

  function applyButtonState(btn) {
    var id = String(btn.getAttribute('data-product-id') || '');
    if (!id) return;
    var list = parseList();
    var on = list.indexOf(id) !== -1;
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function init(root) {
    root = root || document;
    var buttons = root.querySelectorAll('[data-uf-lf-wishlist]');
    if (!buttons.length) return;

    syncCookieToLocalStorage();

    buttons.forEach(function (btn) {
      applyButtonState(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = String(btn.getAttribute('data-product-id') || '');
        if (!id) return;
        var h = String(btn.getAttribute('data-product-handle') || '').trim();
        var list = parseList();
        var i = list.indexOf(id);
        var meta = readMeta();
        if (i === -1) {
          list.push(id);
          if (h) meta[id] = h;
        } else {
          list.splice(i, 1);
          delete meta[id];
        }
        writeMeta(meta);
        persist(list);
        if (window.ufTrack) {
          window.ufTrack(i === -1 ? 'wishlist_add' : 'wishlist_remove', { productId: id, handle: h });
        }
        document.querySelectorAll('[data-uf-lf-wishlist][data-product-id="' + id + '"]').forEach(applyButtonState);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  window.UfLfWishlist = { init: init, parseList: parseList, persist: persist, readMeta: readMeta };
})();
